import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { Field, Notice } from '../../components/ui/misc'
import { authClient } from '../../lib/auth'
import { AuthLayout, authErrorMessage } from './AuthLayout'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(false)
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    await authClient.requestPasswordReset({ email, redirectTo: '/reset-password' })
    setBusy(false)
    setSent(true) // same message whether or not the account exists
  }
  return (
    <AuthLayout title="Reset your password" footer={<Link to="/login" className="font-medium text-brand">Back to sign in</Link>}>
      {sent ? (
        <Notice tone="success">If an account exists for {email}, a reset link is on its way.</Notice>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <Field label="Email">
            <input className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          <Button type="submit" className="h-10 w-full" loading={busy}>
            Send reset link
          </Button>
        </form>
      )}
    </AuthLayout>
  )
}

export function ResetPasswordPage() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(params.get('error') ? 'This reset link is invalid or expired.' : null)
  const navigate = useNavigate()
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!token) return
    setBusy(true)
    const { error: err } = await authClient.resetPassword({ newPassword: password, token })
    setBusy(false)
    if (err) return setError(authErrorMessage(err))
    navigate('/login')
  }
  return (
    <AuthLayout title="Choose a new password">
      {error && (
        <div className="mb-3">
          <Notice tone="warning">{error}</Notice>
        </div>
      )}
      <form onSubmit={submit} className="space-y-3">
        <Field label="New password" hint="At least 10 characters.">
          <input className="input" type="password" minLength={10} required value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Button type="submit" className="h-10 w-full" loading={busy} disabled={!token}>
          Save password
        </Button>
      </form>
    </AuthLayout>
  )
}
